import { AxiosResponse } from 'axios';
import { call, put, select, takeLatest, takeEvery } from 'redux-saga/effects';
import { axiosInstance } from 'setup/axiosInstance';
import { ideasActions } from 'features/feedback/store/ideas.slice';
import { IdeaTO, Page } from 'features/feedback/shared/feedback.types';

export function* fetchIdeasSaga(action: ReturnType<typeof ideasActions.ideasGet>) {
  try {
    const { sort, page } = action.payload;
    const resp: AxiosResponse<Page<IdeaTO>> = yield call(axiosInstance.get, '/feedback/ideas', {
      params: { sort, page: page ?? 0, size: 20 },
    });
    yield put(ideasActions.ideasSet(resp.data));
  } catch (e) {
    console.error(e);
    yield put(ideasActions.ideasError());
  }
}

export function* voteSaga(action: ReturnType<typeof ideasActions.voteToggle>) {
  const id = action.payload;
  const item: IdeaTO | undefined = yield select((s: any) =>
    s.ideas.items.find((i: IdeaTO) => i.id === id),
  );
  if (!item) return;
  try {
    if (item.votedByMe) {
      yield call(axiosInstance.post, `/feedback/ideas/${id}/vote`);
    } else {
      yield call(axiosInstance.delete, `/feedback/ideas/${id}/vote`);
    }
  } catch (e) {
    console.error(e);
    yield put(ideasActions.voteRollback(id));
  }
}

export default function* ideasSaga() {
  yield takeLatest(ideasActions.ideasGet, fetchIdeasSaga);
  yield takeEvery(ideasActions.voteToggle, voteSaga);
}
